// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app[data-v-4e356ab7] {\n  background: #ffffff;\n}\n.ty-drawer-content[data-v-4e356ab7] {\n  width: 94%;\n  margin: 0 auto;\n}\n.ty-drawer-footer[data-v-4e356ab7] {\n  position: absolute;\n  bottom: 24px;\n  left: 0;\n  text-align: center;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
